import {FC} from 'react'
import {useQuery} from 'react-query'
import {RushMindSection} from '../../../../../_metronic/partials/widgets/rushmind/RushMindSection'
import {getRushMindSummary} from '../../../../../_metronic/partials/widgets/rushmind/rushMindSummary'

/**
 * Bloco RushMind do dashboard do colaborador: score de engajamento + cobranças
 * abertas do próprio usuário. Fica logo abaixo da faixa de indicadores de tarefas.
 * Se a chamada falhar, o bloco não renderiza nada (não quebra o dashboard).
 */
const DashboardRushMindSection: FC = () => {
  const {data, isLoading, isError} = useQuery(['rushmind-my-summary'], getRushMindSummary, {
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  })

  if (isError) {
    return null
  }

  if (isLoading || !data) {
    return (
      <div className='dash-section'>
        <h2 className='dash-section-title mb-3'>RushMind</h2>
        <div className='d-flex align-items-center dash-section-subtitle'>
          <span className='spinner-border spinner-border-sm me-2' role='status' />
          Carregando seu engajamento...
        </div>
      </div>
    )
  }

  return (
    <RushMindSection
      rushmind={data}
      isSelf
      title='RushMind'
      subtitle='Seu engajamento no TaskRush e as cobranças abertas pra você. Score de hábitos de uso, não de desempenho profissional.'
    />
  )
}

export {DashboardRushMindSection}
